import React, { useContext, useEffect, useState } from 'react';
import { Box, Heading, ButtonGroup, Flex, useColorModeValue } from '@chakra-ui/react';
import LinkButton from '../../../components/custom/LinkButton';
import AddButton from '../../../components/custom/AddButton';
import { UseApi } from '../../../libraries/UseApi';
import { UserInfoContext } from '../../../provider/UserInfoProvider';
import { UseConstant } from '../../../libraries/UseConstant';
import { UseMessage } from '../../../libraries/UseMessage';
import DeleteButton from '../../../components/custom/DeleteButton';
import Loading from '../../../components/common/Loading';
import NoData from '../../../components/common/NoData';
import SearchBar from '../../../components/search/SearchBar';
import CustomTable from '../../../components/custom/CustomTable';

export default function Branches() {
    const [isProcessing, setIsProcessing] = useState(false);

    const {token} = useContext(UserInfoContext);
    const {constant} = UseConstant();
    const {Message} = UseMessage();
    const {BRANCH_LIST} = constant;

    const { deleteApi } = UseApi();

    const cardBg = useColorModeValue('whiteAlpha.800', 'whiteAlpha.100');

    // ページ番号
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    // 検索パラメータ
    const [searchParams, setSearchParams] = useState({});

    // 取得データ
    const [branches, setBranches] = useState([]);

    const { getApi } = UseApi();
    
    // 検索処理
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getBranches = () => {
        // 処置中チェック
        if (isProcessing) {
            // 処理中の場合、以降の処理を実施しない
            return;
        }
        // 処理中フラグをONにする
        setIsProcessing(true);

        // 検索パラメータ
        let paging = {
            limit: BRANCH_LIST,
            offset: currentPageNo - 1
        };
        let params = { ...paging, ...searchParams };

        // 未受検者検索API
        getApi(
            `${process.env.REACT_APP_API_URL}/branch`, params, { token: token },
            (response) => {
                // 成功時
                if (response.isSuccess === false) {
                    // error
                    alert(Message.Common.ERROR);
                    // 処理中フラグを元に戻す
                    setIsProcessing(false);
                    return;
                }

                setBranches(response.data?.branches);
                setTotalPages(Math.ceil(response.data?.total / paging?.limit));
                // 処理中フラグを元に戻す
                setIsProcessing(false);
            },
            () => {
                // 異常時
                // 処理中フラグをOFFにする
                setIsProcessing(false);
            }
        );
    }

    const handleDelete = (id) => {
        deleteApi(
            `${process.env.REACT_APP_API_URL}/branch/${id}`, { token: token },
            (response) => {
                // レスポンスチェック
                if (response.isSuccess === false) {
                    // 入力内容を確認してください。
                    //alert(Message.Common.CONFIRM_INPUT);
                    return;
                }
                getBranches();
            }
        );        
    };

    useEffect(() => {
        getBranches();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[currentPageNo]);

    const handleSearch = () => {
        setCurrentPageNo(1); 
        getBranches();
    };

    const searchFields = [
        {
            name: 'search_branch',
            label: '部署',
            type: 'text',
        }
    ];

    const handlePageChange = (page) => {
        setCurrentPageNo(page);
    }

    // Define columns
    const columns = [
        { header: '支社', accessor: 'branch' }
    ];

    // Define actions
    const renderActions = (row) => (
        <>
            <LinkButton
                buttonText={'編集'}
                buttonUrl={`/branch/edit/${row.id}`}
            >
            </LinkButton>
            <DeleteButton 
                colorScheme='red'
                handleDelete={handleDelete}
                id={row?.id}
            >
            </DeleteButton>
        </>
    );

    return (
        <Box
            bgGradient="linear(to-br, orange.50, white)"
            minH="100vh"
            w="full"
        >
            {/* Page Header */}
            <Flex
                justify="space-between"
                align="center"
                mb={5}
                flexWrap="wrap"
                gap={4}
            >
                <Heading
                    size="xl"
                    bgGradient="linear(to-r, orange.400, orange.600)"
                    bgClip="text"
                    fontWeight="extrabold"
                >
                    支社一覧
                </Heading>
                <ButtonGroup>
                    <AddButton buttonText="新規登録" buttonUrl="/add-branch" />
                    <LinkButton buttonText="戻る" buttonUrl="/admin-dashboard" />
                </ButtonGroup>
            </Flex>

            {/* Gorgeous Container */}
            <Box
                bg={cardBg}
                boxShadow="xl"
                backdropFilter="blur(10px)"
                p={{ base: 4, md: 8 }}
            >
                {/* Search */}
                <Box mb={6}>
                    <SearchBar
                        searchFields={searchFields}
                        searchParams={searchParams}
                        setSearchParams={setSearchParams}
                        onSearch={handleSearch}
                    />
                </Box>

                {/* Content */}
                {isProcessing ? (
                    <Loading />
                ) : branches.length === 0 ? (
                    <NoData />
                ) : (
                    <CustomTable
                        columns={columns}
                        data={branches}
                        renderActions={renderActions}
                        paginationProps={{
                            currentPage: currentPageNo,
                            totalPages: totalPages,
                            onPageChange: handlePageChange
                        }}
                    />
                )}
            </Box>
        </Box>  
    )
}
